import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/auth/api/auth.service';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

import { UserTableDto } from '../entity/userTableDto';
import { Manufacturer } from '../entity/manufacturer';
import { LicenceTableDto } from '../entity/licenceTableDto';
import { LicenceWizardDto } from '../entity/LicenceWizardDto';
import { LicenceManufacturerTableDto } from '../entity/licenceManufacturerTableDto';
import { ManufacturerRequestDto } from '../entity/manufacturerRequestDto';

@Injectable({
  providedIn: 'root',
})
export class LicenceService {
  constructor(
    private httpClient: HttpClient,
    private router: Router,
    private authService: AuthService
  ) {}

  getUsersByLicence(id: number): Observable<UserTableDto[]> {
    const requestUrl =
      environment.backendUrl + 'api/Licence/GetUsersByLicence/' + id;
    const authHeader = this.authService.getHttpAuthorizationHeader();

    return this.httpClient.get<UserTableDto[]>(requestUrl, {
      headers: authHeader,
    });
  }

  getManufacturersByLicence(
    id: number
  ): Observable<LicenceManufacturerTableDto[]> {
    const requestUrl =
      environment.backendUrl +
      'api/Licence/GetLicenceManufacturerTableForLicence/' +
      id;
    const authHeader = this.authService.getHttpAuthorizationHeader();

    return this.httpClient.get<LicenceManufacturerTableDto[]>(requestUrl, {
      headers: authHeader,
    });
  }

  saveLicence(licence: LicenceTableDto): Observable<Manufacturer[]> {
    const wizard: LicenceWizardDto = new LicenceWizardDto();
    wizard.editLicences.push(licence);

    const requestUrl = environment.backendUrl + 'api/Licence/LicenceWizard/';
    const authHeader = this.authService.getHttpAuthorizationHeader();

    return this.httpClient.post<Manufacturer[]>(requestUrl, wizard, {
      headers: authHeader,
    });
  }

  addLicenceManufacturer(
    dto: LicenceManufacturerTableDto
  ): Observable<Manufacturer[]> {
    const requestUrl =
      environment.backendUrl + 'api/Licence/CreateLicenceManufacturer/';
    const authHeader = this.authService.getHttpAuthorizationHeader();

    return this.httpClient.post<Manufacturer[]>(requestUrl, dto, {
      headers: authHeader,
    });
  }

  deleteLicenceManufacturer(dto: LicenceManufacturerTableDto) {
    const requestUrl =
      environment.backendUrl + 'api/Licence/DeleteLicenceManufacturer/';
    const authHeader = this.authService.getHttpAuthorizationHeader();

    return this.httpClient.post<Manufacturer[]>(requestUrl, dto, {
      headers: authHeader,
    });
  }

  createManufacturerRequest(dto: ManufacturerRequestDto) {
    const requestUrl =
      environment.backendUrl +
      'api/ManufacturerRequest/CreateManufacturerRequest/';
    const authHeader = this.authService.getHttpAuthorizationHeader();

    return this.httpClient.post<ManufacturerRequestDto[]>(requestUrl, dto, {
      headers: authHeader,
    });
  }
}
